import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../../services/language.service';
import { JournalLanguageService } from '../../../services/journal-language.service';
import { Subscription } from 'rxjs';

export interface SocialLink {
  url: string;
  icon: string;
  name: string;
}

@Component({
    selector: 'app-header-controls',
    templateUrl: './header-controls.component.html',
    styleUrls: ['./header-controls.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderControlsComponent implements OnInit, OnDestroy {
  @Input() socialLinks: SocialLink[] = [];
  @Input() showLanguageSelector: boolean = true;
  @Input() showSocialLinks: boolean = true;

  currentLang: string = 'tr';
  supportedLanguages: string[] = [];
  private languageSubscription: Subscription = new Subscription();

  constructor(
    private languageService: LanguageService,
    private journalLanguageService: JournalLanguageService
  ) {}

  ngOnInit(): void {
    this.supportedLanguages = this.languageService.getAvailableLanguages();
    
    // İlk yüklemede cache'den dili al
    this.currentLang = this.languageService.getCurrentLanguage();
    
    // Dil değişikliklerini dinle
    this.languageSubscription = this.languageService.currentLang$.subscribe(
      (language: string) => {
        this.currentLang = language;
      }
    );
    
    // Manuel olarak bir kez daha kontrol et
    setTimeout(() => {
      this.currentLang = this.languageService.getCurrentLanguage();
    }, 100);
  }

  ngOnDestroy(): void {
    this.languageSubscription.unsubscribe();
  }

  // Override showLanguageSelector to respect global journal state
  get shouldShowLanguageSelector(): boolean {
    return this.showLanguageSelector && this.journalLanguageService.shouldShowLanguageSelector();
  }

  setLanguage(language: string): void {
    // Check if language change is allowed
    if (this.journalLanguageService.isLanguageChangeAllowed()) {
      this.languageService.setLanguage(language);
    }
  }

  openSocialLink(url: string): void {
    window.open(url, '_blank');
  }
}
